import service from '@/plugins/service'

const base = '/system/region'

export const getRegions = () => service({
  url: `${base}/list`,
  method: 'GET'
})

export const insertRegion = (type, data) => service({
  url: `${base}/add`,
  method: 'POST',
  params: {
    type
  },
  data
})

export const updateRegion = (type, data) => service({
  url: `${base}/update`,
  method: 'PUT',
  params: {
    type
  },
  data
})

export const deleteRegion = (type, id) => service({
  url: `${base}/remove`,
  method: 'DELETE',
  params: {
    type,
    id
  }
})